export const QUERY_OPTIONS = {
  refetchOnMountOrArgChange: 5,
  refetchOnFocus: true,
  skip: false,
};
